































import { first, isNil, isString } from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { GRANULARITIES } from '@cubejs-client/vue';
import BaseMixin from '@/components/mixins/base';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import DxTextBox from 'devextreme-vue/text-box';

import {
	TCubeDimension
} from '@cubejs-client/core';

import {
	DxMultipleComponentItemType
} from '@/container';

@Component({
	components: {
		DxDropDownBox, DxTreeView, DxTextBox
	}
})
export default class GranularitySelection extends BaseMixin {

	@Prop({ type: Array, default: () => [] }) timeDimensions!: any[];
	@Prop({ type: Array, required: true }) availableTimeDimensions!: TCubeDimension[]
	@Prop({ type: Boolean, default: false }) groupedByWeek!: boolean | null;
	@Prop({ type: Function, default: () => () => void 0 }) setTimeDimensions!: (dim: any[]) => void;

	isTreeBoxOpened = false;
	internalTimeDimensionIds: string[] = [];
	granularities: IGranularity[] = GRANULARITIES;
	isFirstSetUp = false;
	preLoadedGranularity: string | null = null;
	search = '';
	searchButtons = [{
		name: 'search',
		location: 'before',
		options: {
			icon: 'search',
			disabled: true,
			stylingMode: 'text'
		}
	}];

	get treeViewInstance() {
		return (this.$refs['treeView'] as any).instance;
	}

	created() {
			if(this.groupedByWeek == true)
				this.preLoadedGranularity = 'week';

		// needed otherwise it won't select the timeDimenesion inside the drop-down-box
		this.$nextTick(() => {
			const timeDimensions = this.timeDimensions;
			if (Array.isArray(timeDimensions) && timeDimensions.length > 0) {
				this.isFirstSetUp = true;
				const data = first(timeDimensions);
				let id = `${data.dimension.name}_${data.granularity}`;
				if (isString(data.dateRange))
					id = `${id}_${data.dateRange}`;
				this.internalTimeDimensionIds = [id];
				this.treeViewInstance.selectItem(id);
			}
		});
	}

	get treeViewData() {
		let filterFunction: (item: TCubeDimension) => boolean	;
		if (this.search === '') {
			filterFunction = (item: TCubeDimension) => { return true; };
		} else {
			const searchLower = this.search.toLowerCase();
			filterFunction = (item: TCubeDimension) => {
				const translatedName = this.$t(item.name).toString().toLowerCase();
				if (translatedName.includes(searchLower))
					return true;
				return false;
			};
		}

		return this.availableTimeDimensions.filter(filterFunction).flatMap(td => {
			const result: ITreeViewItem[] = this.granularities.flatMap(gr => {
				const treeViewGranularityCaption = `granularity.${gr.title}`;
				return {
					id: `${td.name}_${gr.name}`,
					categoryId: `${td.name}`,
					dimension: td,
					dxDropDownBox: {
						captionCode: [td.name, treeViewGranularityCaption]
					},
					dxTreeView: {
						captionCode: treeViewGranularityCaption
					},
					granularity: gr,
				};
			});
			
			result.unshift({
				id: td.name,
				dxDropDownBox: {
					captionCode: td.name
				},
				dxTreeView: {
					captionCode: td.name
				},
				dimension: td
			});
			return result;
		});
	}

	onItemSelectionChanged({ itemData }: { itemData: ITreeViewItem }) {

		this.isFirstSetUp = false;
		if (!isNil(itemData.granularity)) {
			if(!isNil(this.preLoadedGranularity))	{
				this.$emit('granularityPassed',this.preLoadedGranularity);
				this.preLoadedGranularity = null;
			}
			else
				this.$emit('granularityPassed',itemData.granularity.name);
			this.internalTimeDimensionIds = [itemData.id];

			const timeDimension: any = {
				dimension: itemData.dimension.name,
				granularity: (itemData.granularity.name === 'week' ? 'day' : itemData.granularity.name) || 'day',
			};
			if (!isNil(itemData.dateRange))
				timeDimension.dateRange = itemData.dateRange.filter;

			this.$emit('update:time-dimensions', [timeDimension]);
			this.setTimeDimensions([timeDimension]);
		}
	}

	onTreeItemClick({ itemData }: { itemData: ITreeViewItem }) {
		if (!isNil(itemData.granularity))
			this.isTreeBoxOpened = false;
	}

	onDropDownBoxValueChanged({ previousValue, value }: {
		previousValue: string[] | null,
		value: string[] | null
	}) {
		if (isNil(value)) {
			this.treeViewInstance.unselectAll();
			this.$emit('granularityPassed', ' ');
			this.$emit('update:time-dimensions', []);
			this.setTimeDimensions([]);
		}
	}
}

interface ITreeViewItem extends DxMultipleComponentItemType {
	id: string;
	dimension: TCubeDimension;
	categoryId?: string;
	dateRange?: IDateRange;
	granularity?: IGranularity;
}

interface IDateRange {
	name: string;
	filter: string;
}

interface IGranularity {
	name?: string;
	title: string;
	byWeek: boolean;
}

